module.exports = __webpack_public_path__ + "img/web-08.8d668662.gif";